<template> 
   
    <transition name="fade" appear>
    <div >

            <div id='widget-home'  class="fadein" :class='{fadeout:$store.getters.zoom > 12.7  }'>
                
                 <div class='headline-top mb2 laranja' >
                    <div><small>Resultado</small></div>
                    <div>  <a style='font-size:14px;font-weight:400' href='http://voltadolago.com.br/resultado_oficial_20_edicao.html' target="_blank">20º Edição - Resultado Oficial</a></div>
                    <div>  <a style='font-size:14px;font-weight:400' href='http://voltadolago.com.br/images/resultado-20-revezamento.pdf' target="_blank">20º Edição - Revezamento (pdf)</a></div>
                    <div>  <a style='font-size:14px;font-weight:400' href='http://voltadolago.com.br/images/resultado-20-individual.pdf' target="_blank">20º Edição - Solo (pdf)</a></div>
                    <!-- <div>  <a href='//voltadolago.com.br/images/resultado-extraoficial-20-individual.pdf' target="_blank">Solo </a></div> -->
                </div>  
<!--
                  <div class='headline-top mb2 azul' >
                    <a href='#' target="_blank">{{$t('RETIRADA DO KIT')}}</a><br/> Mormaii Surf Bar, Ponte JK  17/5 9h as 21h 
                </div>
               

             
            <!-- <div class='headline-top mb2 ' > 
                <div class='mt-3' >
                         <b>18ª Edição - </b>
                    </div>
                     <div class='mt-3' >
                        <a href='/images/resultado-18-voltadolago.pdf' target="_blank"> RESULTADO OFICIAL <br/>  18ª Edição </a>
                    </div>
                     <p class='mt-3' >
                        <a  style='font-size:12px;font-weight:400' href="https://largadaesportiva.com.br/myregistrations"  target="_blank" class=""> <i class='fa fa-user' /> Acesse suas inscrições </a>              
                    </p>
            </div>  -->

           <!-- <div class='headline-top mb2 laranja' >
                    <div class='mt-3' >
                         <b style='font-size:1.6rem;font-weight:600'>20ª Edição</b>
                    </div>
                    <div class='mt-1 mb-3' >
                         <b style="font-size:0.9rem;font-weight:300">05 de Julho de 2026</b>
                    </div>
                    <p class='mt-3' >
                      
                     <b style="font-size:1.2rem;font-weight:600">  <a  target="_blank" style='font-size:18px;font-weight:800' href="https://largadaesportiva.com.br/myregistrations"  class=""> Envie o Tracklog da sua corrida</a>              </b>
                    </p>
                </div>   

                <div class="widgets" v-pan style="display:block">
                         <div class='widget'>
                            <div class="header">{{$t('Faltam')}}</div>
                            <div class="body ">  {{days}} </div>
                            <div class="footer">{{$t('dias')}}</div>
                        </div> 
                        <div class='widget'>
                            <div class="header">{{$t('Distância')}}</div>
                            <div class="body"> <i class='vtl vtl-percurso'></i> </div>
                            <div class="footer">100 km</div>
                        </div>
                        <div class='widget'>
                            <div class="header">{{$t('Previsão do Tempo')}}</div>
                            <div class="body"> <i class='fa fa-thermometer-three-quarters'></i> </div>
                            <div class="footer">
                                    <div>
                                        <div> 24º C  <span class='fw1 f7'><i class=' fa-w fa fa-arrow-up'></i></span> </div>
                                        <div> <span class='fw2'> 18º C </span> <span class='fw1 f7'><i class=' fa-w fa fa-arrow-down'></i></span> </div>
                                    </div>
                            </div>
                        </div>
                        <div class='widget'>
                            <div class="header">{{$t('Altimetria')}}</div>
                            <div class="body"> <i class='vtl vtl-altimetria'></i> </div>
                            

                            <div class="footer">
                                
                                    <div>
                                        <div> {{((elevationUp)/1000).toFixed(2)}} <span class='fw1 f7'><i class=' fa-w fa fa-arrow-up'></i></span> </div>
                                        <div> <span class='fw2'> {{((elevationDown)/1000).toFixed(2)}} </span> <span class='fw1 f7'><i class=' fa-w fa fa-arrow-down'></i></span> </div>
                                    </div>
                            </div>
                        </div>
                        
                </div> -->
                
                <!-- <div class="fotter-widget ttu">
                    {{ $d(new Date('2026-07-06'), 'daymonth') }}
                   
                </div> -->


      

                <div class='social'>
                    <social />
                </div>

                <div class='assinaturas mt1 '  :class='{fadeout:$store.getters.zoom > 12.7  }'>
                    <ajaxcontent url="logos" :showLoader="false"></ajaxcontent>
                </div>


            </div>

          

   </div>
        </transition>



</template>



<script>
 
 export default {
    name: 'home',

    data(){
        return{
            cpf:"06989062177",
            cd_equipe:"3048",

        }
    },

    created:function(){
        $('html').addClass('home');
        setTimeout(()=> UIEvents.$emit('resizeMapContainer'),400);


        // var watchID = navigator.geolocation.watchPosition(function(position) {
        //             do_something(position.coords.latitude, position.coords.longitude);
        // });

    },

    destroyed:function(){
         $('html').removeClass('home');
         setTimeout(()=> UIEvents.$emit('resizeMapContainer'),400)
    },

    computed:{
        days:function(){
            var date1 = new Date();
            var date2 = new Date('2026-07-05');
            // The number of milliseconds in one day
            var ONE_DAY = 1000 * 60 * 60 * 24
            // Convert both dates to milliseconds
            var date1_ms = date1.getTime()
            var date2_ms = date2.getTime()
            // Calculate the difference in milliseconds
            var difference_ms = Math.abs(date1_ms - date2_ms)
            // Convert back to days and return
            return Math.round(difference_ms/ONE_DAY)
        },

        course:function(){
            return this.$store.getters.courses
        },
        stats:function(){
            return _.courseStats(this.course)
        },
        elevationUp:function(){
            return this.stats.dist_up;
        },

        elevationDown:function(){
            return this.stats.dist_down;
        }


    },
 }

</script>

<style lang="stylus" >

    @import "../css/variaveis";

   
    
    .info{
        +mobile(){
            display:none !important;
        }
    }


    #widget-home{
        box r 50px t 50px 
        width 250px;
        text-align center;



       +mobile(){
            // top: 75vh;
            position:relative;
            // bottom:60px;
            right: 5px;
            left: 5px;
            // top:60%;
            // height initial;
            width:100%;;
            opacity 1 !important; //para o zoom nao desaparecer os widgets como acontece no desktop
        }

        .social{
            margin-top:0.3em;
            text-align:center;
            width 100%;
            ul{
                width 100%;
            }
            li{
                display:inline-block !important;
            }
            a{
                color:white;
                font-size:1.3em;
            }

        }
        

        .headline-top{
            background  color-orange;
            color white;
            text-transform uppercase;
            font-family font-title;
            padding 0.6em 1em;
            width 100%;
            a{
                color:white;
                font-weight 600;
                font-family font-subtitle;
                font-size:1.1rem;
            }

            &.azul{
                     background  color-dark-gray;
            }
        }

        .widgets{
            overflow:hidden;
            background  color-dark-gray;
            width 100%;
            height 110px;
            margin-top:3px;
            border-top 5px solid color-orange;
            color:lighten(color-dark-gray,40%);

            font-size:1rem;

            +mobile(){
                  height 100px;
                  font-size:0.7rem;
            }
        }

        .widget{

            font-size:0.8rem;
            bordercolor = lighten(color-dark-gray,20%);
            height 100%;
            display:block;
            float:left;
            width 33%;
            border-right:1px solid bordercolor
            text-align center;
            color:lighten(color-dark-gray,40%);
            position:relative;
            line-height:1;

            .header{    
                box t 10 h 20% r 10 l 10
                text-transform uppercase;
                font-family font-subtitle;
                font-size:0.7em;
            }

            .body{
                box t 20% b 20% r 10 l 10;
                text-align:center;
                color:lighten(color-dark-gray,50%);
                display: flex;
                -webkit-box-align: center!important;
                -ms-flex-align: center!important;
                align-items: center!important;
                justify-content: center;

                font-family font-subtitle;
                font-size:2em;
                font-weight 900;
                color:lighten(color-dark-gray,50%);

                i{
                     font-size:1.2em;
                }
                
            }

            .footer{
                box b 5px h 20% r 10 l 10
                font-family font-subtitle;
                font-size:1em;
                font-weight 900;
                color:lighten(color-dark-gray,50%);
                text-transform uppercase;

                 display: flex;
                -webkit-box-align: center!important;
                -ms-flex-align: center!important;
                align-items: center!important;
                justify-content: center;

            }
        }


        .fotter-widget{
            background  color-dark-gray;
            width 100%;
            color:lighten(color-dark-gray,40%);
            border-top: 1px solid lighten(color-dark-gray,20%);
            font-family font-subtitle;
            font-size:1.1em;
            font-weight 900;
            padding: 0.5em 0em;

        }

    }


  .secao{
        text-align:center;
        padding-top:3em;
        padding-bottom:5em;
        position:relative;
        cursor:pointer;

        img{
            margin-bottom:2.5em;
            
        }

        h5{
            color: cor-azul;
            font-size:0.8rem;
            margin:0;
        }
        h2{
            color:cor-verde;
            font-weight: 600;
            font-size:2.0rem;
            margin-bottom:2rem;
        }

        .descricao,.desc{
            font-size:0.85rem;
            line-height:1.5;
            color:lighten(black,45%);
            text-align:left;
            p{
                color:inherit;
            }
        }

        &:nth-child(2){
            border-left: tipo = 1px solid lighten(black,85%);;
            border-right:tipo;
        }

        .seta{
            box abs b 20px r 40px
            color:cor-verde;
            font-size:3em;
            opacity:0.2;
            transition: 200ms;
        }

        &:hover{
            .seta{
                opacity:0.8;
                transition: 200ms;
            }
        }
    }
    .disable-gray {
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
            
    }


    .assinaturas{

        color:white;
        text-align:center;
        position: fixed;
        bottom: 1em;
        right: 2em;

        .row .col{
            text-align: right;
        
        
        }
        

        .img-2x{
            img{
                // scale 110%;
            }
        }

        +mobile(){
            position: initial;
            bottom: initial;
            right: initial;
            // position: relative !important;
            // position: fixed;
            // bottom: 0;
            right:0;
            left:5px;
            height:50px;
            margin:0;
            width:100%;


            & > div{
                transform:scale(0.45);
                transform-origin: 0 0;
            }
          

           #assinaturas{
            //    width 1200px;

           
           }

            .row:first-child{
                display:none;
            }

            .row{
                    display:block !important;
                    float:left;
            }
        
        }
    
        .secaologo{
            // text-algin:left;
            .apoio-type{
                text-align:left;
            }
        }
    }


</style>